import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { MessageService } from 'primeng/api';
import _ from 'lodash';
import { LoaderComponent } from '../../loader/loader.component';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { RFQService } from '../../../services/rfq.service';
import { gridPageRequest, Product, Rfq } from '../../../model/common/common.model';
import { Warehouse } from '../../../model/administration.model';
import { AdministratorService } from '../../../services/administrator.service';
import { VendorService } from '../../../services/vendor.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { VendorLookupComponent } from '../../Lookup/vendor-lookup/vendor-lookup.component';
import { rfqVendor, vendor } from '../../../model/masters.model';
import { SalesService } from '../../../services/sales.service';
import { GetproductLookupComponent } from '../../Lookup/getproduct-lookup/getproduct-lookup.component';
import { RFQProductLookupComponent } from '../../Lookup/FRQProduct-lookup/FRQProduct-lookup.component';
import { ConfirmationService } from 'primeng/api';
import { Table } from 'primeng/table';
import { POCommentsLookupComponent } from '../../Lookup/pocomments-lookup/pocomments-lookup.component';
import { InventoryService } from '../../../services/inventory.service';

@Component({
  selector: 'app-create-products',
  standalone: true,
  imports: [SharedModule, CommonModule, LoaderComponent, TieredMenuModule],
  providers: [MessageService, ConfirmationService],
  templateUrl: './create-rfq.component.html',
  styleUrl: './create-rfq.component.scss'
})

export class CreateRFQComponent implements OnInit {

  loader: boolean = false;
  isEditMode: boolean = false;
  submitted: boolean = false;
  isManual: boolean = false;
  Rfq: Rfq[] = [];
  product: Product[] = [];
  warehouseDropdown: Warehouse[] = [];
  filterWarehouses: Warehouse[] = [];
  VendorList: any[] = [];
  selectedVendor: rfqVendor[] = [];
  Vendors: rfqVendor[] = [];
  filterProductList: any[] = [];
  Products: any[] = [];
  selectedProducts: Product[] = [];
  showPriceModal: boolean = false;
  productList: any;
  vendorProductPrices: { [vendorId: string]: any[] } = {};
  rfqId: any;
  RfqVendorId: any;
  qty: any;
  quotedPrice: any;
  leadTime: any;
  freight: any;
  updatedProducts: any;
  currentPriceDialogVendor: any = null;
  vendorDeletedIds: number[] = [];
  productDeletedIds: number[] = [];
  @ViewChild('vendorTable') vendorTable: Table | undefined;
  @ViewChild('productTable') productTable: Table | undefined;
  unitLabel: string = '';

  constructor(private messageService: MessageService, private router: Router, private Rfqservice: RFQService,
    private administratorService: AdministratorService, private vendorService: VendorService,
    public ref: DynamicDialogRef, public dialogService: DialogService, private salesService: SalesService,
    private route: ActivatedRoute, private confirmationService: ConfirmationService, public inventoryService: InventoryService) { }


  ngOnInit(): void {
    document.title = 'Create RFQ';
    this.RfqDetailsForm.controls.CreatedBy.setValue(localStorage.getItem('username'));

    this.getWarehouse();
    this.fetchAndPatchRFQ();
    this.manualEntry();
    this.inventoryService.getUnitByAppKey('unitNameLabel')
      .subscribe((res: any) => {
        this.unitLabel = res?.data || 'Unit';
      });
  }


  RfqDetailsForm = new FormGroup({
    rfqCode: new FormControl('', Validators.required),
    rfqName: new FormControl('', Validators.required),
    warehouse: new FormControl('', Validators.required),
    WareHouseId: new FormControl('', Validators.required),
    warehouseCode: new FormControl(''),
    warehouseState: new FormControl(''),
    CreatedBy: new FormControl(''),
    upatedBy: new FormControl(''),
    manualEntry: new FormControl(false),
    vendor: new FormControl(),
    vendorId: new FormControl(),
    vendorName: new FormControl(''),
    vendorCode: new FormControl(''),
    add: new FormControl(),
    productCode: new FormControl(''),
    rfqDate: new FormControl<Date | null>(null, Validators.required),

  });


  get formControls() {
    return this.RfqDetailsForm.controls;
  }

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 100,
    id: 0
  }

  validateForm() {
    let isValid = true;
    if (this.RfqDetailsForm.invalid) {
      isValid = false;
    }

    for (const product of this.Products) {
      if (!product.qty || !product.requiredDate || !product.salesPrice) {
        isValid = false;
        break;
      }
    }

    return isValid;
  }

  manualEntry() {
    const manualEntryValue = this.RfqDetailsForm.controls.manualEntry.value;
    if (manualEntryValue === true) {
      this.RfqDetailsForm.controls.rfqCode.setValue('');
      this.isManual = false;
    } else {
      if (!this.isEditMode) {
        this.isManual = true
        this.getRfqCode();
      }
    }
  }


  getRfqCode() {
    this.loader = true;
    this.Rfqservice.autogenerateRfqCode().subscribe({
      next: (data: any) => {
        // const alphanumericCode = 'R';
        // const vendorCode = alphanumericCode + data;
        this.RfqDetailsForm.controls.rfqCode.setValue(data.fullNumber);
        this.loader = false;
      },
      error: (error: any) => {
        console.log(error);
        this.loader = false;
      }
    });
  }

  saveRfq(data: any, isEditMode: boolean) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' });
      return;
    }

    if (isEditMode) {
      this.updateRfq(data);
    } else {
      this.createRfq(data);
    }
  }


  createRfq(data: any) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    const payload = {
      rfqCode: data.rfqCode,
      rfqName: data.rfqName,
      rfqDate: data.rfqDate,
      warehouseId: data.WareHouseId,
      warehouseCode: data.warehouseCode,
      warehouseState: data.warehouseState,
      createdBy: data.CreatedBy,
      updatedBy: data.upatedBy,
      isActive: true
    };

    const currentTime = new Date();
    payload.rfqDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
    this.Rfqservice.createRFQ(payload).subscribe({
      next: (response: any) => {
        if (response.success === true) {
          this.rfqId = response.id;
          this.messageService.add({ severity: 'success', summary: 'Request for Quote Created Successfully', detail: response.message });
          this.createRfqVendors()
            .then(() => this.createRfqProducts())
            .then(() => {
              this.loader = true;
              setTimeout(() => {
                this.router.navigate(['/home/listrfq']);
              }, 500);
            })
            .catch(error => {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to create RFQ related data.' });
            });

        } else {
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: response.message });
        }
      },
      error: error => {
        console.error('Error creating Request for Quote:', error);
        this.loader = false;
      }
    });
  }

  createRfqVendors(): Promise<any> {
    const payload = this.Vendors.filter(v => !v.rfqVendorId || v.rfqVendorId === 0).map(vendor => ({
      vendorCode: vendor.vendorCode,
      vendorName: vendor.vendorName,
      addressId: vendor.addressId,
      vendorId: vendor.vendorId,
      mobile: vendor.mobile || '',
      email: vendor.email,
      isActive: true,
      createdBy: localStorage.getItem('username'),
      createdDate: new Date(),
      rfqID: this.rfqId,
    }));

    // const missing = payload.find(v => !v.vendorCode || !v.vendorName || !v.addressId || !v.vendorId || !v.rfqID || !v.createdBy);
    // if (missing) {
    //   this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Vendor data is incomplete. Please check all fields.' });
    //   this.loader = false;
    //   return Promise.reject('Vendor data is incomplete.');
    // }

    return new Promise((resolve, reject) => {
      if (payload.length === 0) {
        resolve([]);
        return;
      }

      this.Rfqservice.createRFQVendors(payload).subscribe({
        next: (response: any) => {
          if (response && response.vendors) {
            response.vendors.forEach((createdVendor: any, index: number) => {
              const localVendor = this.Vendors.find(v => v.vendorCode === createdVendor.vendorCode);
              if (localVendor) {
                localVendor.rfqVendorId = createdVendor.rfqVendorId;
              }
            });
          } else if (response && Array.isArray(response)) {
            response.forEach((createdVendor: any, index: number) => {
              const localVendor = this.Vendors.find(v => v.vendorCode === createdVendor.vendorCode);
              if (localVendor) {
                localVendor.rfqVendorId = createdVendor.rfqVendorId;
              }
            });
          }

          resolve(response);
        },
        error: error => {
          console.error('Error creating RFQ Vendors:', error);
          this.loader = false;
          reject(error);
        }
      });
    });
  }


  createRfqProducts(): Promise<any> {
    const payload: any[] = [];

    this.Vendors.forEach(vendor => {
      const vendorId = Number(vendor.vendorId);
      const rfqVendorId = vendor.rfqVendorId;
      this.Products.forEach(product => {
        const vendorProduct = (this.vendorProductPrices[vendorId] || []).find(p => p.productCode === product.productCode) || {};
        let salesPrice = 0;
        if (vendorProduct.salesPrice !== undefined && vendorProduct.salesPrice !== null && vendorProduct.salesPrice !== '') {
          salesPrice = Number(vendorProduct.salesPrice);
        } else if (product.salesPrice !== undefined && product.salesPrice !== null && product.salesPrice !== '') {
          salesPrice = Number(product.salesPrice);
        }
        const quotedPrice = vendorProduct.quotedPrice !== undefined && vendorProduct.quotedPrice !== null && vendorProduct.quotedPrice !== '' ? Number(vendorProduct.quotedPrice) : 0.00;
        const freight = vendorProduct.freight !== undefined && vendorProduct.freight !== null && vendorProduct.freight !== '' ? Number(vendorProduct.freight) : 0;
        const leadTime = vendorProduct.leadTime !== undefined && vendorProduct.leadTime !== null && vendorProduct.leadTime !== '' ? Number(vendorProduct.leadTime) : 0.00;
        const qty = vendorProduct.qty !== undefined && vendorProduct.qty !== null && vendorProduct.qty !== '' ? Number(vendorProduct.qty) : (product.qty ?? 0);
        const requiredDate = vendorProduct.requiredDate ?? product.requiredDate;
        payload.push({
          rfqProductCode: product.productCode,
          rfqVendorId: rfqVendorId,
          rfqID: this.rfqId,
          description: product.productName,
          unitsOfMeasureId: product.unitsofMeasureId ?? null,
          unitsOfMeasureCode: product.unitsOfMeasure,
          salesPrice: salesPrice,
          freight: freight,
          leadTime: leadTime,
          quotedPrice: quotedPrice,
          qty: qty,
          comment: product.Comment,
          requiredDate: this.fixDate(requiredDate),
          isActive: true,
          createdBy: localStorage.getItem('username'),
          updatedBy: localStorage.getItem('username'),
          createdDate: new Date(),
          updatedDate: new Date(),
        });
      });
    });

    return new Promise((resolve, reject) => {
      if (payload.length === 0) {
        resolve([]);
        return;
      }

      this.Rfqservice.createRFQProducts(payload).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: error => {
          this.loader = false;
          reject(error);
        }
      });
    });
  }


  fixDate(date: any): Date | null {
    if (!date) return null;
    const correctedDate = new Date(date);
    const now = new Date();
    correctedDate.setHours(now.getHours(), now.getMinutes(), now.getSeconds());
    return correctedDate;
  }


  updateRfq(data: any) {
    this.loader = true;
    const isValid = this.validateForm();
    if (!isValid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' });
      return;
    }
    const rfqPayload = {
      rfqCode: this.RfqDetailsForm.value.rfqCode,
      rfqName: this.RfqDetailsForm.value.rfqName,
      rfqDate: this.formatDateOnly(this.RfqDetailsForm.value.rfqDate),
      warehouseId: this.RfqDetailsForm.value.WareHouseId,
      warehouseCode: this.RfqDetailsForm.value.warehouseCode,
      isActive: true,
      rfqId: this.rfqId,
      createdBy: localStorage.getItem('username'),
      updatedBy: localStorage.getItem('username'),
      createdDate: new Date(),
      updatedDate: new Date(),
    };
    this.Rfqservice.updateRFQ(rfqPayload).subscribe({
      next: (res: any) => {
        const newVendors = this.Vendors.filter(v => !v.rfqVendorId || v.rfqVendorId === 0);
        const existingVendors = this.Vendors.filter(v => v.rfqVendorId && v.rfqVendorId > 0);
        let vendorUpdatePromise = Promise.resolve();
        if (existingVendors.length > 0) {
          vendorUpdatePromise = new Promise((resolve, reject) => {
            this.Rfqservice.updateRFQVendors(existingVendors).subscribe({
              next: () => resolve(),
              error: err => reject(err)
            });
          });
        }
        let vendorCreatePromise = Promise.resolve([]);
        if (newVendors.length > 0) {
          const payload = newVendors.map(vendor => ({
            vendorId: vendor.vendorId,
            vendorCode: vendor.vendorCode,
            vendorName: vendor.vendorName,
            addressId: vendor.addressId,
            mobile: vendor.mobile || '',
            email: vendor.email || '',
            isActive: true,
            gstin: vendor.gstin || '',
            tags: vendor.tags || '',
            website: vendor.website || '',
            vendorDescription: vendor.vendorDescription || '',
            phone: vendor.phone ? String(vendor.phone) : '',
            type: vendor.type || '',
            createdBy: localStorage.getItem('username'),
            createdDate: new Date(),
            rfqID: this.rfqId
          }));

          vendorCreatePromise = new Promise((resolve, reject) => {
            this.Rfqservice.createRFQVendors(payload).subscribe({
              next: (response: any) => {
                if (response && response.vendors) {
                  response.vendors.forEach((createdVendor: any) => {
                    const localVendor = this.Vendors.find(v => v.vendorCode === createdVendor.vendorCode);
                    if (localVendor) {
                      localVendor.rfqVendorId = createdVendor.rfqVendorId;
                    }
                  });
                }
                resolve(response.vendors || []);
              },
              error: err => reject(err)
            });
          });
        }

        Promise.all([vendorUpdatePromise, vendorCreatePromise])
          .then(() => {
            const newProducts: any[] = [];
            const updatedProducts: any[] = [];
            const updatedProductIds = new Set();
            this.Vendors.forEach(vendor => {
              const vendorId = Number(vendor.vendorId);
              this.Products.forEach(product => {
                const vendorProduct = (this.vendorProductPrices[vendorId] || []).find(p => p.productCode === product.productCode);
                const baseProduct = vendorProduct || product;
                const salesPrice = baseProduct.salesPrice !== undefined && baseProduct.salesPrice !== null && baseProduct.salesPrice !== '' ? Number(baseProduct.salesPrice) : 0;
                const quotedPrice = baseProduct.quotedPrice !== undefined && baseProduct.quotedPrice !== null && baseProduct.quotedPrice !== '' ? Number(baseProduct.quotedPrice) : 0.00;
                const freight = baseProduct.freight !== undefined && baseProduct.freight !== null && baseProduct.freight !== '' ? Number(baseProduct.freight) : 0;
                const leadTime = baseProduct.leadTime !== undefined && baseProduct.leadTime !== null && baseProduct.leadTime !== '' ? Number(baseProduct.leadTime) : 0.00;
                if (!baseProduct.rfqProductId || baseProduct.rfqProductId === 0) {
                  newProducts.push({
                    rfqProductCode: product.productCode,
                    description: product.productName,
                    unitsOfMeasureId: product.unitsofMeasureId ?? null,
                    unitsOfMeasureCode: product.unitsOfMeasure,
                    salesPrice: salesPrice,
                    freight: freight,
                    leadTime: leadTime,
                    quotedPrice: quotedPrice,
                    qty: baseProduct.qty ?? 0,
                    comment: product.Comment,
                    requiredDate: this.fixDate(baseProduct.requiredDate),
                    isActive: true,
                    createdBy: localStorage.getItem('username'),
                    updatedBy: localStorage.getItem('username'),
                    createdDate: new Date(),
                    updatedDate: new Date(),
                    rfqVendorId: vendor.rfqVendorId,
                    rfqID: this.rfqId,
                  });
                } else {
                  if (!updatedProductIds.has(baseProduct.rfqProductId)) {
                    updatedProducts.push({
                      rfqProductId: baseProduct.rfqProductId,
                      rfqProductCode: product.productCode,
                      description: product.productName,
                      unitsOfMeasureId: product.unitsofMeasureId ?? null,
                      unitsOfMeasureCode: product.unitsOfMeasure,
                      salesPrice: salesPrice,
                      freight: freight,
                      leadTime: leadTime,
                      quotedPrice: quotedPrice,
                      qty: baseProduct.qty ?? 0,
                      comment: product.Comment,
                      requiredDate: this.fixDate(baseProduct.requiredDate),
                      isActive: true,
                      createdBy: localStorage.getItem('username'),
                      updatedBy: localStorage.getItem('username'),
                      createdDate: new Date(),
                      updatedDate: new Date(),
                      rfqVendorId: vendor.rfqVendorId,
                      rfqID: this.rfqId,
                    });
                    updatedProductIds.add(baseProduct.rfqProductId);
                  }
                }
              });
            });
            let productCreatePromise = Promise.resolve();
            if (newProducts.length > 0) {
              productCreatePromise = new Promise((resolve, reject) => {
                this.Rfqservice.createRFQProducts(newProducts).subscribe({
                  next: () => resolve(),
                  error: err => reject(err)
                });
              });
            }
            let productUpdatePromise = Promise.resolve();
            if (updatedProducts.length > 0) {
              productUpdatePromise = new Promise((resolve, reject) => {
                this.Rfqservice.updateRFQProducts(updatedProducts).subscribe({
                  next: () => resolve(),
                  error: err => reject(err)
                });
              });
            }
            const deleteVendorPromises = this.vendorDeletedIds.map(id => this.Rfqservice.deleteRFQVendor(id).toPromise());
            const deleteProductPromises = this.productDeletedIds.map(id => this.Rfqservice.deleteRFQProduct(id).toPromise());
            return Promise.all([productCreatePromise, productUpdatePromise, ...deleteVendorPromises, ...deleteProductPromises]);
          })
          .then(() => {
            this.vendorDeletedIds = [];
            this.productDeletedIds = [];
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RFQ updated successfully.' });
            setTimeout(() => {
              this.router.navigate(['/home/listrfq']);
              this.loader = false;
            }, 500);
          })
          .catch(error => {
            this.loader = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update vendors/products.' });
          });
      },
      error: (err: any) => {
        this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update RFQ.' });
      }
    });
  }

  createRfqProductsWithPayload(payload: any[]): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!payload || payload.length === 0) {
        resolve([]);
        return;
      }
      this.Rfqservice.createRFQProducts(payload).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error);
        }
      });
    });
  }

  getUpdatedProductsForExistingVendors(): any[] {
    const updatedProducts: any[] = [];
    this.Vendors.filter(v => v.rfqVendorId && v.rfqVendorId > 0).forEach(vendor => {
      const vendorId = Number(vendor.vendorId);
      const products = this.vendorProductPrices[vendorId] || [];
      products.forEach(product => {
        if (product.rfqProductId && product.rfqProductId > 0) {
          updatedProducts.push({
            rfqProductId: product.rfqProductId,
            rfqProductCode: product.productCode,
            description: product.productName,
            unitsOfMeasureId: product.unitsofMeasureId ?? null,
            unitsOfMeasureCode: product.unitsOfMeasure,
            salesPrice: product.salesPrice,
            freight: product.freight !== undefined && product.freight !== null && product.freight !== '' ? Number(product.freight) : 0,
            leadTime: product.leadTime !== undefined && product.leadTime !== null && product.leadTime !== '' ? Number(product.leadTime) : 0.00,
            quotedPrice: product.quotedPrice !== undefined && product.quotedPrice !== null && product.quotedPrice !== '' ? Number(product.quotedPrice) : 0.00,
            qty: product.qty ?? 0,
            requiredDate: this.fixDate(product.requiredDate),
            isActive: true,
            createdBy: localStorage.getItem('username'),
            updatedBy: localStorage.getItem('username'),
            createdDate: new Date(),
            updatedDate: new Date(),
            rfqVendorId: vendor.rfqVendorId,
            rfqID: this.rfqId,
          });
        }
      });
    });
    return updatedProducts;
  }

  updateRfqProductsForExistingVendors(products: any[]): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!products || products.length === 0) {
        resolve([]);
        return;
      }
      this.Rfqservice.updateRFQProducts(products).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error);
        }
      });
    });
  }

  getProduct() {
    this.ref = this.dialogService.open(GetproductLookupComponent, {
      header: 'Product List',
      width: '60%',
      data: { Material: 'FG1112' }
    });

    this.ref.onClose.subscribe((selectedProduct: any) => {
      if (selectedProduct) {
        const products = Array.isArray(selectedProduct) ? selectedProduct : [selectedProduct];
        let updated = false;

        products.forEach(product => {
          const alreadyExists = this.Products.some(p => p.productCode === product.productCode);
          if (!alreadyExists) {
            this.Products.push({ ...product, qty: 0, Comment: '' });
            updated = true;
          }
        });

        if (updated) {
          this.Products = [...this.Products];

          setTimeout(() => {
            if (this.productTable) {
              const rowsPerPage = this.productTable.rows || 5;
              const lastPageStartIndex = Math.floor((this.Products.length - 1) / rowsPerPage) * rowsPerPage;
              this.productTable.first = lastPageStartIndex;
            }
          }, 0);
        }
      }
    });
  }


  setProduct(selectedProduct: any) {
    const alreadyExists = this.Products.some(p => p.productCode === selectedProduct.productCode);
    if (!alreadyExists) {
      const productWithQty = { ...selectedProduct, qty: 0, Comment: '' };
      this.Products = [...this.Products, productWithQty.value || productWithQty];

      setTimeout(() => {
        if (this.productTable) {
          const rowsPerPage = this.productTable.rows || 5;
          const lastPageStartIndex = Math.floor((this.Products.length - 1) / rowsPerPage) * rowsPerPage;
          this.productTable.first = lastPageStartIndex;
        }
      }, 0);
    }

    this.RfqDetailsForm.controls.productCode.setValue('');
    this.filterProductList = [];
  }


  autosearchProduct(event: any) {
    this.salesService.autoSearchProduct(event.query).subscribe(
      (data: any[]) => {
        if (data) {
          this.filterProductList = data
            .map(product => ({
              ...product,
              formattedCode: `${product.productCode} - ${product.productName}`
            }));
        } else {
          this.filterProductList = [];
        }
      },
      (error: any) => {
        console.error('Error fetching products:', error);
      }
    );
  }


  checkVendorCode() {
    if (!this.RfqDetailsForm.controls.rfqCode.value) {
      this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Please enter' });
      return;
    }
    if (!this.isEditMode) {
      this.Rfqservice.checkRfqCode(this.RfqDetailsForm.controls.rfqCode.value).subscribe(
        (data: any) => {
          if (data.success == true) {
            // console.log(data);
          } else {
            this.RfqDetailsForm.controls.rfqCode.setValue('');
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
            this.RfqDetailsForm.controls.manualEntry.setValue(true);
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }

  setVendor(selectedVendor: any) {
    const alreadyExists = this.Vendors.some(v => v.vendorId === selectedVendor.vendorId);
    if (!alreadyExists) {
      this.Vendors.push(selectedVendor.value);
      const vendorId = Number(selectedVendor.value.vendorId);
      if (!this.vendorProductPrices[vendorId]) {
        this.vendorProductPrices[vendorId] = [];
      }
      this.Products.forEach(product => {
        const alreadyInVendor = this.vendorProductPrices[vendorId].some(p => p.productCode === product.productCode);
        if (!alreadyInVendor) {
          this.vendorProductPrices[vendorId].push({
            productId: null,
            productCode: product.productCode,
            productName: product.productName,
            unitsOfMeasure: product.unitsOfMeasure,
            unitsOfMeasureId: product.unitsofMeasureId,
            qty: 0,
            quotedPrice: 0,
            salesPrice: product.salesPrice || 0,
            freight: 0,
            leadTime: product.leadTime !== undefined && product.leadTime !== null && product.leadTime !== '' ? Number(product.leadTime) : null,
            requiredDate: null,
            rfqVendorId: selectedVendor.value.rfqVendorId,
            rfqProductId: null
          });
        }
      });
      setTimeout(() => {
        if (this.vendorTable) {
          const rowsPerPage = this.vendorTable.rows || 5;
          const lastPageStartIndex = Math.floor((this.Vendors.length - 1) / rowsPerPage) * rowsPerPage;
          this.vendorTable.first = lastPageStartIndex;
        }
      }, 0);
    }
    this.RfqDetailsForm.controls.vendorName.setValue('');
    this.RfqDetailsForm.controls.vendorId.setValue('');
  }


  autosearchVendor(event: any) {
    this.vendorService.autoSearchVendor(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.VendorList = data;
        } else {
          console.log(data);
        }
      },
      (error: any) => {
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed to search vendor' });
        console.log(error);
      }
    );
  }

  getVendor() {
    this.ref = this.dialogService.open(VendorLookupComponent, {
      header: 'Vendor List',
      width: '60%',
    });

    this.ref.onClose.subscribe((data: any) => {
      if (!data) return;

      const newVendors = Array.isArray(data) ? data : [data];

      newVendors.forEach(vendor => {
        const alreadyExists = this.Vendors.some(v => v.vendorId === vendor.vendorId);
        if (!alreadyExists) {
          this.Vendors.push(vendor);
        }
      });

      setTimeout(() => {
        if (this.vendorTable) {
          const rowsPerPage = this.vendorTable.rows || 5;
          const lastPageStartIndex = Math.floor((this.Vendors.length - 1) / rowsPerPage) * rowsPerPage;
          this.vendorTable.first = lastPageStartIndex;
        }
      }, 0);

      this.RfqDetailsForm.controls.vendorName.setValue('');
    });
  }


  setWarehouse(data: any) {
    if (data.value) {
      this.RfqDetailsForm.controls.WareHouseId.setValue(data.value.warehouseId);
      this.RfqDetailsForm.controls.warehouseCode.setValue(data.value.warehouseCode);
      this.RfqDetailsForm.controls.warehouseState.setValue(data.value.address.state);
    }
  }

  filterWarehouse(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.warehouseDropdown as any[]).length; i++) {
      let warehouse = (this.warehouseDropdown as any[])[i];
      if (warehouse.warehouseName.toLowerCase().indexOf(query.toLowerCase()) == 0 ||
        warehouse.warehouseCode.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(warehouse);
      }
    }

    this.filterWarehouses = filtered;
  }

  getWarehouse() {
    this.administratorService.getAllWarehouse(this.pageRequest).subscribe({
      next: (data: any) => {
        this.warehouseDropdown = data.warehouses;
        // console.log(data);
      },
      error: error => {
        console.log(error);
      }
    });
  }

  cancel() {
    this.router.navigate(['/home/listrfq']);
  }

  onKeydown(event: KeyboardEvent) {
    console.log('Keydown event:', event);

    if (event.key === 'Enter') {
      this.moveToNextField(event);
    }
  }

  moveToNextField(event: KeyboardEvent) {
    const inputs = Array.from(document.querySelectorAll('input')) as HTMLInputElement[];
    const index = inputs.indexOf(event.target as HTMLInputElement);
    if (index > -1 && index < inputs.length - 1) {
      (inputs[index + 1] as HTMLInputElement).focus();
    }
  }

  focusNextInput(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();

    const target = keyboardEvent.target as HTMLElement;
    const formElements = Array.from((target.closest('form') as HTMLFormElement).elements) as HTMLElement[];
    const index = formElements.indexOf(target);

    if (index > -1 && index < formElements.length - 1) {
      const nextElement = formElements[index + 1];
      nextElement.focus();
    }
  }

  openProductPriceLookup(vendor: any) {
    this.currentPriceDialogVendor = vendor;
    const vendorId = Number(vendor.vendorId);

    this.Products.forEach(product => {
      const exists = (this.vendorProductPrices[vendorId] || []).some(p => p.productCode === product.productCode);
      if (!exists) {
        if (!this.vendorProductPrices[vendorId]) {
          this.vendorProductPrices[vendorId] = [];
        }
        this.vendorProductPrices[vendorId].push({
          productId: null,
          productCode: product.productCode,
          productName: product.productName,
          unitsOfMeasure: product.unitsOfMeasure,
          unitsOfMeasureId: product.unitsofMeasureId,
          qty: product.qty,
          quotedPrice: 0,
          salesPrice: product.salesPrice || 0,
          freight: 0,
          leadTime: null,
          requiredDate: product.requiredDate,
          rfqVendorId: vendor.rfqVendorId,
          rfqProductId: null
        });
      } else {
        const vendorProduct = this.vendorProductPrices[vendorId].find(p => p.productCode === product.productCode);
        if (vendorProduct) {
          vendorProduct.qty = product.qty;
          vendorProduct.requiredDate = product.requiredDate;
        }
      }
    });

    const productsForVendor: any[] = this.Products.map(product => {
      const existing = this.vendorProductPrices[vendorId].find(p => p.productCode === product.productCode);
      return {
        productId: product.productId,
        productCode: product.productCode,
        productName: product.productName,
        unitsOfMeasure: product.unitsOfMeasure,
        unitsOfMeasureId: product.unitsofMeasureId,
        qty: existing?.qty ?? product.qty ?? '',
        quotedPrice: existing?.quotedPrice ?? '',
        salesPrice: product.salesPrice ?? '',
        freight: existing?.freight ?? '',
        leadTime: existing?.leadTime ?? '',
        requiredDate: existing?.requiredDate ?? product.requiredDate ?? null,
        rfqVendorId: vendor.rfqVendorId,
        rfqProductId: existing?.rfqProductId
      };
    });

    this.ref = this.dialogService.open(RFQProductLookupComponent, {
      header: `RFQ Price Entry for ${vendor.vendorName}`,
      width: '65%',
      data: {
        vendor,
        products: productsForVendor,
        updatedProducts: this.updatedProducts
      }
    });

    this.ref.onClose.subscribe((updatedProducts: any[]) => {
      if (updatedProducts) {
        this.vendorProductPrices[vendorId] = updatedProducts;
        updatedProducts.forEach(up => {
          const mainProduct = this.Products.find(p => p.productCode === up.productCode);
          if (mainProduct) {
            mainProduct.qty = up.qty;
            mainProduct.requiredDate = up.requiredDate;
          }
        });
      }
    });
  }


  onProductQtyChange(product: any) {
    if (!product || !product.productCode) return;
    for (const vendorId in this.vendorProductPrices) {
      const vendorProducts = this.vendorProductPrices[vendorId];
      const index = vendorProducts.findIndex(p => p.productCode === product.productCode);
      if (index !== -1) {
        vendorProducts[index].qty = product.qty;
      }
    }
  }

  onProductDateChange(product: any) {
    if (!product || !product.productCode) return;
    for (const vendorId in this.vendorProductPrices) {
      const vendorProducts = this.vendorProductPrices[vendorId];
      const index = vendorProducts.findIndex(p => p.productCode === product.productCode);
      if (index !== -1) {
        vendorProducts[index].requiredDate = product.requiredDate;
      }
    }
  }

  onProductPriceChange(product: any) {
    if (!product || !product.productCode) return;
    for (const vendorId in this.vendorProductPrices) {
      const vendorProducts = this.vendorProductPrices[vendorId];
      const index = vendorProducts.findIndex(p => p.productCode === product.productCode);
      if (index !== -1) {
        vendorProducts[index].salesPrice = product.salesPrice;
      }
    }
  }

  handleQtyInputChange(value: any, product: any) {
    const qty = Number(value);
    product.qty = qty;
    this.onProductQtyChange(product);
  }


  fetchAndPatchRFQ(): void {
    this.loader = true;

    this.route.queryParams.subscribe(params => {
      this.rfqId = params['rfqId'];
      this.isEditMode = !!this.rfqId;

      if (!this.rfqId) {
        this.loader = false;
        return;
      }
      document.title = 'Update RFQ';
      this.Rfqservice.getRFQById(this.rfqId).subscribe({
        next: (data: any) => {
          this.loader = false;

          const warehouseObj = this.warehouseDropdown?.find(w => w.warehouseId === data.warehouseId);
          this.RfqDetailsForm.patchValue({
            rfqCode: data.rfqCode,
            rfqName: data.rfqName,
            rfqDate: data.rfqDate ? new Date(data.rfqDate) : null,

            warehouse: warehouseObj || data.warehouseCode || '',
            WareHouseId: data.warehouseId,
            warehouseCode: data.warehouseCode,
          });

          this.Vendors = (data.rfqVendors || []).map((vendor: any) => {
            const actualVendor = vendor.address?.vendor?.[0];
            return {
              ...vendor,
              vendorId: actualVendor?.vendorId || vendor.vendorId,
              vendorCode: actualVendor?.vendorCode || vendor.vendorCode,
              vendorName: actualVendor?.vendorName || vendor.vendorName,
              mobile: actualVendor?.mobile || vendor.mobile,
              email: actualVendor?.email || vendor.email,
              phone: actualVendor?.phone || vendor.phone,
            };
          });

          const productsByVendor = new Map();
          const uniqueProductsMap = new Map();

          (data.rfqProducts || []).forEach((product: any) => {
            const vendor = this.Vendors.find(v => v.rfqVendorId === product.rfqVendorId);
            const vendorId = vendor?.vendorId || product.rfqVendorId;

            if (!productsByVendor.has(vendorId)) {
              productsByVendor.set(vendorId, []);
            }
            productsByVendor.get(vendorId).push(product);

            const key = product.rfqProductCode;
            if (!uniqueProductsMap.has(key)) {
              uniqueProductsMap.set(key, {
                productId: product.rfqProductId,
                productCode: product.rfqProductCode,
                productName: product.description,
                unitsOfMeasure: product.unitsOfMeasureCode,
                unitsOfMeasureId: product.unitsofMeasureId,
                qty: product.qty,
                freight: product.freight !== undefined && product.freight !== null && product.freight !== '' ? Number(product.freight) : 0,
                leadTime: product.leadTime !== undefined && product.leadTime !== null && product.leadTime !== '' ? Number(product.leadTime) : 0.00,
                quotedPrice: product.quotedPrice !== undefined && product.quotedPrice !== null && product.quotedPrice !== '' ? Number(product.quotedPrice) : 0.00,
                salesPrice: product.salesPrice,
                requiredDate: product.requiredDate ? new Date(product.requiredDate) : null,
                rfqVendorId: product.rfqVendorId,
                rfqProductId: product.rfqProductId,
                Comment: product.comment || product.Comment || ''
              });
            }
          });

          this.Products = Array.from(uniqueProductsMap.values()).map(product => ({
            ...product,
            Comment: product.Comment || ''
          }));

          this.vendorProductPrices = {};
          this.Vendors.forEach((vendor: any) => {
            const vendorId = Number(vendor.vendorId);
            const vendorProducts = productsByVendor.get(vendorId) || [];

            this.vendorProductPrices[vendorId] = vendorProducts.map((product: any) => ({
              productId: product.rfqProductId,
              productCode: product.rfqProductCode,
              productName: product.description,
              unitsOfMeasure: product.unitsOfMeasureCode,
              unitsOfMeasureId: product.unitsofMeasureId,
              qty: product.qty,
              quotedPrice: product.quotedPrice !== undefined && product.quotedPrice !== null && product.quotedPrice !== '' ? Number(product.quotedPrice) : 0.00,
              salesPrice: product.salesPrice,
              freight: product.freight !== undefined && product.freight !== null && product.freight !== '' ? Number(product.freight) : 0,
              leadTime: product.leadTime !== undefined && product.leadTime !== null && product.leadTime !== '' ? Number(product.leadTime) : 0,
              requiredDate: product.requiredDate ? new Date(product.requiredDate) : null,
              rfqVendorId: product.rfqVendorId,
              rfqProductId: product.rfqProductId,
            }));
          });

        },

        error: (err: any) => {
          this.loader = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch RFQ.' });
          console.error('Error fetching RFQ:', err);
        }
      });
    });
  }


  onQtyBlur(event: any, product: any) {
    const inputValue = +event.target.value;
    this.qty = inputValue;
    product.qty = inputValue;
  }

  onDateSelect(event: any, product: any) {
    product.requiredDate = event;

    for (const vendorId in this.vendorProductPrices) {
      const vendorProducts = this.vendorProductPrices[vendorId];
      const index = vendorProducts.findIndex(p => p.productCode === product.productCode);
      if (index !== -1) {
        vendorProducts[index].requiredDate = event;
      }
    }
  }

  deleteVendor(vendor: any) {
    this.confirmationService.confirm({
      message: `Please confirm to proceed.`,
      header: 'Are you sure?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        if (vendor.rfqVendorId) {
          this.vendorDeletedIds.push(vendor.rfqVendorId);
        }

        this.Vendors = this.Vendors.filter(v => v.rfqVendorId !== vendor.rfqVendorId);
        const vendorId = Number(vendor.vendorId);
        delete this.vendorProductPrices[vendorId];

        this.messageService.add({
          severity: 'success',
          summary: 'Vendor Deleted',
          detail: `Vendor ${vendor.vendorName || ''} removed successfully.`,
          life: 3000
        });
      }
    });
  }


  deleteProduct(product: any) {
    this.confirmationService.confirm({
      message: `Please confirm to proceed.`,
      header: 'Are you sure?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        if (product.rfqProductId) {
          this.productDeletedIds.push(product.rfqProductId);
        }

        this.Products = this.Products.filter(p => p.productCode !== product.productCode);

        for (const rfqProductId in this.vendorProductPrices) {
          this.vendorProductPrices[rfqProductId] = this.vendorProductPrices[rfqProductId].filter(p => p.productCode !== product.productCode);
        }

        this.messageService.add({
          severity: 'success',
          summary: 'Product Deleted',
          detail: `Product ${product.productCode} removed successfully.`,
          life: 3000
        });
      }
    });
  }

  formatDateOnly(date: Date | null | undefined): string | null {
    if (!date) return null;
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  showComment(productItem: Product) {
    this.ref = this.dialogService.open(POCommentsLookupComponent, {
      header: 'RFQ Products Remark',
      width: '50%',
      data: productItem
    });
    this.ref.onClose.subscribe((data: string) => {
      if (data) {
        productItem.Comment = data;
        this.onCommentEdit(productItem);
      }
    });
  }

  onCommentEdit(product: any) {
    const code = product.productCode || product.ProductCode;
    const idx = this.Products.findIndex(p => (p.productCode || p.ProductCode) === code);
    if (idx !== -1) {
      this.Products[idx].Comment = product.Comment;
      (this.Products[idx] as any).comment = product.Comment;
      this.Products = [...this.Products];
    }
  }

  showReport(data?: any) {

  }

}


